/** Shared-workspace disclosure shown on the sign-in gate and logged at startup. */
export const SHARED_WORKSPACE_NOTICE =
  "TENURE uses a shared authenticated workspace. Workspace members can view, edit and delete the same scenarios, sites and builder quotes. Passcode access stays on this device only.";
